module.exports = "/images/no-matches.png?ed2f88ea19f3f2dc52e4314b604b40a8";